if (!customElements.get('pp-surface-shop')) {
  customElements.define('pp-surface-shop', class PPSurfaceShop extends HTMLElement {
    connectedCallback() {
      this.onClick = this.onClick.bind(this);
      this.onChange = this.onChange.bind(this);
      this.onVariantAdded = this.onVariantAdded.bind(this);
      this.addEventListener('click', this.onClick);
      this.addEventListener('change', this.onChange);
      this.addEventListener('variant:add', this.onVariantAdded);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('variant:add', this.onVariantAdded);
    }
    onClick(event) {
      const button = event.target.closest('[data-surface-qty-minus], [data-surface-qty-plus]');
      if (!button) return;
      const input = button.closest('[data-surface-quantity]')?.querySelector('input');
      if (!input) return;
      const value = Number.parseInt(input.value, 10) || 1;
      input.value = button.hasAttribute('data-surface-qty-plus') ? value + 1 : Math.max(1, value - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    onChange(event) {
      if (event.target.matches('[data-surface-quantity] input')) {
        const value = Number.parseInt(event.target.value, 10);
        event.target.value = Number.isFinite(value) ? Math.max(1, value) : 1;
        return;
      }
      if (!event.target.matches('[data-surface-variant-select]')) return;
      const card = event.target.closest('[data-pp-surface-card]');
      const option = event.target.selectedOptions[0];
      const input = card.querySelector('[data-surface-variant-input]');
      const add = card.querySelector('[data-surface-add]');
      const price = card.querySelector('[data-surface-price]');
      const stock = card.querySelector('[data-surface-stock]');
      const valid = Boolean(option?.value);
      const available = valid && option.dataset.available === 'true';
      input.value = valid ? option.value : '';
      input.disabled = !available;
      price.innerHTML = valid ? `<span>${option.dataset.price}</span>${option.dataset.comparePrice ? `<s>${option.dataset.comparePrice}</s>` : ''}` : '<span>Choose an option</span>';
      stock.textContent = valid ? (available ? 'In stock' : 'Sold out') : 'Select an available option';
      add.disabled = !available;
      add.querySelector('span').textContent = available ? 'Add to Basket' : (valid ? 'Sold out' : 'Choose an Option');
      add.dataset.defaultLabel = add.querySelector('span').textContent;
    }
    onVariantAdded(event) {
      const form = event.target.closest('.pp-surface-card__form');
      const button = form?.querySelector('[data-surface-add]');
      if (!button) return;
      const label = button.querySelector('span');
      window.clearTimeout(button.ppSuccessTimeout);
      button.classList.add('is-added');
      label.textContent = 'Added to Basket';
      button.ppSuccessTimeout = window.setTimeout(() => {
        button.classList.remove('is-added');
        label.textContent = button.dataset.defaultLabel;
      }, 1800);
    }
  });
}